import React from 'react';

export function escapeHtmlHelper(text) {

    const urltext = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;

    if (text) {
        return text
            .replace(/â€“/g, "—")
            .replace(/â€”/g, "_")
            .replace(/â€"/g, "—")
            .replace(/â€œ/g, "“")
            .replace(/â€/g, "”")
            .replace(/â€¦/g, "...")
            .replace(/â€¢/g, "-")
            .replace(/â€˜/g, "'")
            .replace(/â€™/g, "'")
            .replace(/â‚¬/g, "€")
            .replace(/Â/g, " ")
            .replace(/â€š/g, ",")
            .replace(/â€¦/g, "...")
            .replace(/Â¢/g, "¢")
            .replace(/â„¢/g, "™")
            .replace(/Â£/g, "£")
            .replace(/Â/g, " ")
            .replace(/Ëœ/g, "˜")
            .replace(/â€/g, "'")
            .replace(/â€/g, "'")
            .replace(/&#163;/g, "£")
            .replace(urltext, "<a href='$1'>$1</a>");
    }
}




// WEBPACK FOOTER //
// src/client/helpers/MarkupHelpers.js